import { Dispatch, SetStateAction, useState } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms";
import { DropDownIcon, StudyPlannerPlusIcon } from "components/atoms/Icon";
import { useGetStudyPlannerAdditionalItemsQuery } from "services/studyPlanner";
import "./index.scss";

interface IProps {
  onClick?: () => void;
  setDropDownClicked: Dispatch<SetStateAction<boolean>>;
  dropDownClicked: boolean;
  handleAdd: any;
  date: any
}

export const NestedDropDown = ({
  setDropDownClicked,
  dropDownClicked,
  handleAdd,
  date
}: IProps) => {
  const [selectedSubject, setSelectedSubject] = useState<string | null>(null);
  const [selectedSubSubject, setSelectedSubSubject] = useState<boolean>(false);
  const [expandedSubSubjects, setExpandedSubSubjects] = useState<
    Record<string, boolean>
  >({});
  const { data } = useGetStudyPlannerAdditionalItemsQuery();

  const handleClick = () => {
    setDropDownClicked((prev) => !prev);
    setSelectedSubject("");
  };

  const handleSubSubjectClick = (subSubject: string) => {
    setExpandedSubSubjects((prev) => ({
      ...prev,
      [subSubject]: !prev[subSubject],
    }));
  };

  const handleSubjectClick = (subject: string) => {
    setSelectedSubject(subject);
    setExpandedSubSubjects({});
  };

  const subjectNames = [
    "Biology",
    "CARS",
    "General Chemistry",
    "Organic Chemistry",
    "Physics",
    "Psychology/Sociology",
  ];

  const subSubjectNames = [
    "Biology Class 1 - Biochemistry I",
    "Biology Class 2 - Biochemistry II",
    "Biology Class 3 - Molecular Biology",
    "Biology Class 4 - Microbiology",
    "Biology Class 5 - Cell Biology",
    "Biology Class 6 - Genetics",
    "Biology Class 7 - Nervous System",
    "Biology Class 8 - Endocrine, Cardiovascular, Immunology",
    "Biology Class 9 - Renal and Digestive Systems",
    "Biology Class 10 - Muscular, Skeletal and Respiratory Systems",
    "Biology Class 11 - Reproduction and Development",
  ];

  const subSubjectContainsNames = [
    "Redox and Intro to Cellular",
    "Respiration",
    "Glycolysis",
    "PDC/Krebs Cycle",
    "ETC, Ox Phos, Fermentation",
    "Gluconeogenesis and Reciprocal",
    "Regulation",
    "Glycogenesis",
    "Pentose Phosphate Pathway",
    "Fatty Acid Oxidation",
    "Fatty Acid Synthesis",
    "Ketogenesis",
    "Protein Catabolism",
    "Summary of Metabolism",
  ];

  return (
    <div className={classNames("nested-drop-down-wrapper")}>
      <div
        className={classNames("drop-down", {
          "drop-down-icon-rotate": dropDownClicked,
        })}
        onClick={handleClick}
      >
        <input
          placeholder={
            data.ItemsGrouped[0].ContentItemsDropdownTitle || "Search"
          }
          type="text"
        />
        <DropDownIcon />
      </div>

      {dropDownClicked && (
        <div className="subject-section">
          {!selectedSubject &&
            data &&
            data.ItemsGrouped[0].ContentItemsGrouped.map(
              (subject: any, index: number) => (
                <div
                  className="subject"
                  onClick={() => handleSubjectClick(subject.SubGroupName)}
                  key={index}
                >
                  <div className="typography-holder">
                    <Typography
                      label={subject.SubGroupName}
                      variant="h9Medium"
                    />
                  </div>
                </div>
              )
            )}

          {selectedSubject &&
            data &&
            data.ItemsGrouped[0].ContentItemsGrouped.find(
              (group: any) => group.SubGroupName === selectedSubject
            ).SubGroupItems.map((subSubject: any, index: number) => (
              <div
                className="sub-subject"
                onClick={() =>
                  handleSubSubjectClick(subSubject.GroupedItemName)
                }
                key={index}
              >
                <div className="sub-typography-holder">
                  <Typography
                    label={subSubject.GroupedItemName}
                    variant="h9Medium"
                  />
                  <div
                    className={classNames("sub-icon-holder", {
                      clicked: expandedSubSubjects[subSubject.GroupedItemName],
                    })}
                  >
                    <DropDownIcon />
                  </div>
                </div>

                {expandedSubSubjects[subSubject.GroupedItemName] && (
                  <div className="subject-content-wrapper">
                    {Object.entries(subSubject.ContentItems).map(
                      (item: any, index: number) => (
                        <div className="sub-subject-content" key={index}>
                          <StudyPlannerPlusIcon onClick={() => handleAdd(item[0], date)} />
                          <Typography
                            label={item[1]}
                            variant="h9Medium"
                            styles="typography-custom-style"
                            onClick={() => handleAdd(item[0], date)}
                          />
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
